import type { AgendaStatusValue, AgendaTipoValue } from "@/api/db/connection";
import { djs } from "@/lib/djs";

import { OperacaoLabels } from "./operacao";

const agendaStatusLabel: Record<AgendaStatusValue, string> = {
	agendado: "agendado",
	confirmado: "confirmado",
	em_espera: "em espera",
	em_atendimento: "em atendimento",
	finalizado: "finalizado",
	faltou: "faltou",
	cancelado: "cancelado",
	cancelado_remoto: "cancelado no GestãoDS",
};

const agendaStatusChip: Record<AgendaStatusValue, string> = {
	agendado: "border-border bg-background text-muted-foreground",
	confirmado: "border-info/40 bg-info/10 text-info",
	em_espera: "border-warning/40 bg-warning/10 text-warning",
	em_atendimento: "border-whatsapp/40 bg-whatsapp/10 text-whatsapp",
	finalizado: "border-primary/30 bg-primary/10 text-primary",
	faltou: "border-destructive/40 bg-destructive/10 text-destructive",
	cancelado: "border-destructive/40 bg-destructive/10 text-destructive",
	cancelado_remoto: "border-destructive/40 bg-destructive/10 text-destructive",
};

export const agendaTipoLabel: Record<AgendaTipoValue, string> = {
	Consulta: "Consulta",
	Retorno: "Retorno",
	Cirurgia: "Cirurgia",
	Procedimento: "Procedimento",
	Bloqueio: "Bloqueio",
};

const agendaTipoDot: Record<AgendaTipoValue, string> = {
	Consulta: "bg-info",
	Retorno: "bg-warning",
	Cirurgia: "bg-primary",
	Procedimento: "bg-whatsapp",
	Bloqueio: "bg-muted-foreground",
};

const agendaTipoBlock: Record<AgendaTipoValue, string> = {
	Consulta: "border-l-info bg-info/15 text-info",
	Retorno: "border-l-warning bg-warning/15 text-warning",
	Cirurgia: "border-l-primary-hover bg-primary text-primary-foreground",
	Procedimento: "border-l-whatsapp bg-whatsapp/15 text-whatsapp",
	Bloqueio: "hachura border-l-muted/70 text-muted-foreground",
};

const weekdayShort: Record<number, string> = {
	0: "dom",
	1: "seg",
	2: "ter",
	3: "qua",
	4: "qui",
	5: "sex",
	6: "sáb",
};

export const AgendaLabels = {
	status: agendaStatusLabel,
	statusChip: agendaStatusChip,
	tipo: agendaTipoLabel,
	tipoDot: agendaTipoDot,
	tipoBlock: agendaTipoBlock,
	weekday(dateIso: string) {
		return weekdayShort[djs(dateIso, "YYYY-MM-DD").day()];
	},
	fresh: "agenda atualizada",
	stale(syncedAt: string | null) {
		return syncedAt === null ? "agenda sem atualização" : "agenda desatualizada";
	},
	syncFailed(syncedAt: string | null) {
		return syncedAt === null ? "agenda indisponível" : "falha na atualização da agenda";
	},
	updatedAt(syncedAt: string) {
		return `última atualização ${OperacaoLabels.lastAt(syncedAt)}`;
	},
	dayLabel(dateIso: string) {
		const date = djs(dateIso, "YYYY-MM-DD");

		return `${weekdayShort[date.day()]} ${date.format("DD/MM")}`;
	},
	updateAction: "Atualizar",
	updatingAction: "Atualizando...",
	emptyDay: "nada agendado",
	emptyWeek: "nenhum agendamento nesta semana",
	loadError: "Não foi possível carregar a agenda.",
	saveError(code?: string) {
		if (code === "APPOINTMENT_OVERLAP") {
			return "Já existe um horário nesse período.";
		}

		return "Não foi possível salvar o horário.";
	},
	telemedicina: "telemedicina",
	inPulso: "No Pulso",
	cadastroLink: "paciente no cadastro",
	noMatch: "sem cadastro correspondente",
	prevWeek: "Semana anterior",
	nextWeek: "Próxima semana",
	backToCurrentWeek: "Voltar para esta semana",
};
